import 'cropperjs/dist/cropper.js';
import Cropper from 'cropperjs';


class ImageCrop  {

    components = {Cropper};
 
    // constructor(elem) {
    //     this.elem = elem;
    //     this.imageElem = elem.querySelector('img');
    //     this.imageInput = elem.querySelector('input[type=file]');
    //     this.resetInput = elem.querySelector('input[data-reset-input]');
    //     this.removeInput = elem.querySelector('input[data-remove-input]');

    //     this.defaultImage = elem.getAttribute('data-default-image');

    //     const resetButton = elem.querySelector('button[data-action="reset-image"]');
    //     resetButton.addEventListener('click', this.reset.bind(this));

    //     const removeButton = elem.querySelector('button[data-action="remove-image"]');
    //     if (removeButton) {
    //         removeButton.addEventListener('click', this.removeImage.bind(this));
    //     }

    //     this.imageInput.addEventListener('change', this.fileInputChange.bind(this));
    // }

    setup(){
        this.container = this.$el;
        this.imageElem = this.$refs.source;
        this.preview = this.$refs.preview;
        this.imageInput = this.$refs.imageinput;
        this.resetInput = this.$refs.resetinput;
        this.removeInput = this.$refs.removeinput;
        this.cropInput = this.$refs.cropinput;
        this.defaultImage = this.$opts.defaultimage;
        this.removeName = this.$opts.removeName;
        this.resetButton = this.$refs.resetbutton;
        this.removeButton = this.$refs.removebutton;
        this.cropper;
        this.setupListeners();
    }

    setupListeners(){
        // Reset Button Listener
        if (this.resetButton) {
            this.resetButton.addEventListener('click', this.reset.bind(this));
        }

        // Remove Button Listener
        if (this.removeButton) {
            this.removeButton.addEventListener('click', this.removeImage.bind(this));
        }

        // File Input change
        this.imageInput.addEventListener('change', this.fileInputChange.bind(this));
    }

    fileInputChange() {
        this.resetInput.setAttribute('disabled', 'disabled');
        if (this.removeInput) {
            this.removeInput.setAttribute('disabled', 'disabled');
        }
     
        let $this = this;
        for (let file of this.imageInput.files) {
            this.imageElem.src = window.URL.createObjectURL(file);
            if(this.cropper){
                this.cropper.destroy(); 
                this.cropper = null;
            }
            
            this.cropper = new Cropper(this.imageElem ,{
            autoCropArea: 0.7,
            viewMode: 1,
            center: true,
            dragMode: 'move',
            movable: true,
            scalable: true,
            guides: true,
            preview:$this.preview,
            zoomOnWheel: false,
            zoomable: false,
            cropBoxMovable: true,
            wheelZoomRatio: 0.1,
            ready: function () {
            //Should set crop box data first here
            // cropper.setCropBoxData(cropBoxData).setCanvasData(canvasData);
            $this.cropInput.value =  JSON.stringify($this.cropper.getData());

            },
            crop(event) {
                $this.cropInput.value =  JSON.stringify($this.cropper.getData());

              },
          });
        }
        this.imageElem.classList.remove('none');

        
    }

    reset() {
        if(this.cropper){
            this.cropper.destroy(); 
            this.cropper = null;
        }
        this.imageInput.value = '';
        this.imageElem.src = this.defaultImage;
        this.resetInput.removeAttribute('disabled');
        if (this.removeInput) {
            this.removeInput.setAttribute('disabled', 'disabled');
        }
        this.imageElem.classList.remove('none');
    }

    removeImage() {
        if(this.cropper){
            this.cropper.destroy(); 
            this.cropper = null;
        }
        this.imageInput.value = '';
        this.imageElem.classList.add('none');
        this.removeInput.removeAttribute('disabled');
        this.resetInput.setAttribute('disabled', 'disabled');
    }

    

}

export default ImageCrop;